import Dropdown from "react-bootstrap/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import { SessionKeys } from "../../utils/AppUtils";
import _ from "lodash";
import { useEffect, useState } from "react";
import { getOfficeListReq } from "../../redux/assignCourse/actions";
import { useTranslation } from "react-i18next";
const OfficeSelectComp = (props) => {
    const {selectedOfficeList, setSelectedOfficeList, getLeaderBoardData} = props;
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const officeListRes = useSelector((state) => state.assignCourse.officeList);
	const [officeList, setOfficeList] = useState([]);
  const [officeListForFilter, setOfficeListForFilter] = useState([]);
  const [searchValue,setSearchValue] = useState('');



    useEffect(()=>{searchOffice()},[])

    const searchOffice = () => {
		// console.log('officeListRes1')
		dispatch(getOfficeListReq({
			module: 'getOfficeListSearch',
			postData: {
				token:  localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
				search: '',
				type: 'report'
			}
		}))
	}

  useEffect(()=>{
    if(searchValue===undefined || _.isEmpty(searchValue)){
      setOfficeList(officeListForFilter);
    }else{
      let tempList= officeListForFilter?.filter((item)=>{return item?.office_name?.toLowerCase().includes(searchValue.toLowerCase()) })
      setOfficeList(tempList)
    }
  },[searchValue])

	useEffect(() => {
		// console.log('officeListRes: ', officeListRes)
		if (!_.isEmpty(officeListRes)) {
			if (officeListRes?.status === 'success') {
				const officeArr = officeListRes?.payload?.payload
				setOfficeList(officeArr);
        setOfficeListForFilter(officeArr);

			} else {
				setOfficeList([])
        setOfficeListForFilter([])
			}
		} else {
			setOfficeList([])
      setOfficeListForFilter([]);
		}
	}, [officeListRes])


    
    const [isAllSelected, setIsAllSelected] = useState(false);
  
    const clickAllSelectedUser = () => {
  
      if (isAllSelected) {
        setSelectedOfficeList([])
        setIsAllSelected(false);
      } else {
        let selectedArr = [];
        for (let index = 0; index < officeListForFilter.length; index++) {
          const item = officeListForFilter[index];
          selectedArr.push(item);
        }
        setSelectedOfficeList(selectedArr);

        if(selectedArr.length===officeListForFilter.length){
          setIsAllSelected(true)
        }
      }
  
    }
  
  
    const addRemindSelectedUser = (item, isRemove) => {
      console.log("inner:::::");
      if (isRemove) {
        let filteredArr = [];
        for (let i = 0; i < selectedOfficeList.length; i++) {
          const element = selectedOfficeList[i];
            if (element.office_id !== item.office_id) {
              filteredArr.push(element);
            }
        }
        setSelectedOfficeList(filteredArr);
        if(filteredArr.length<officeListForFilter.length){
          setIsAllSelected(false)
        }
      } else {
        
        let selectedArr = _.cloneDeep(selectedOfficeList);
        selectedArr.push(item);
        setSelectedOfficeList(selectedArr);
        if(selectedArr.length===officeListForFilter.length){
          setIsAllSelected(true)
        }
      }
    };
    const isExistId = (item) => {
      let isExist = false;
      for (let i = 0; i < selectedOfficeList.length; i++) {
        const element = selectedOfficeList[i];
        
          if (element.office_id === item.office_id) {
            isExist = true;
            break;
          }
      }
  
      return isExist;
    };

    
    return (<>
        <Dropdown className="filter-btn">
              <Dropdown.Toggle
                className="filter-btn-bn"              
                //variant="secondary"
               id="dropdown-basic"
               align="end"
              >
                {t("Offices")} <svg xmlns="http://www.w3.org/2000/svg" width="20" height="10" viewBox="0 0 20 10" fill="none"><path d="M18.9587 1.78879L10.7517 9.65205C10.4939 9.86695 10.236 9.95285 10.0212 9.95285C9.7634 9.95285 9.50559 9.86695 9.29074 9.69505L1.04074 1.78879C0.611052 1.40207 0.611052 0.714569 0.99777 0.327849C1.38449 -0.101839 2.07199 -0.101839 2.45871 0.284879L10.0212 7.50363L17.5407 0.284879C17.9274 -0.101839 18.615 -0.101839 19.0017 0.327849C19.3884 0.714569 19.3884 1.40207 18.9587 1.78879Z" fill="#2D2D2D"></path></svg>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <div className="dropdown-menu-filter" id="avail_menu">
                  <div className="dropdown-search">
                    <div className="dropdown-item-se pos-r">
                      <input
                        type="search"
                        className="form-control-search input_field mb-0"
                        placeholder={t("Search")}
                        value={searchValue}
                        onChange={(evt)=>{
                          setSearchValue(evt.target.value);
                        }}
                      />
                      <i className="filter-searchicon"></i>
                    </div>
                  </div>
                  <div className="drop-multiselect">
                    <div className="bdr-row">
                      <div className="form-check checkallvalue" onClick={() => {
                        clickAllSelectedUser()
                      }}>
                        <input
                          aria-label="Select all (6)"
                          tabindex="0"
                          type="checkbox"
                          class="form-check-input"
                          id="selectallvaluecontentType"
                          checked={isAllSelected}
                        />
                        <label className="form-check-label" id="selectallvalue">
                          {t("Select All")}
                        </label>
                      </div>

                     {officeList.map((item,index)=>{
                        return <div className="form-check"
                        onClick={() => {
                            if (isExistId(item)) {
                              addRemindSelectedUser(item, true);
                            } else {
                              addRemindSelectedUser(item, false);
                            }
                          }}>
                        <input type="checkbox" className="form-check-input" checked={isExistId(item)}/>
                        <label className="form-check-label" id="level">
                          {item.office_name}
                        </label>
                      </div>
                     }) }
                    </div>
                  </div>
                  <div className="filter-btnrow" id="avl_applybtn">
                    <button type="button" className="upload-review-btn" onClick={()=>{
                      setSelectedOfficeList([])
                      setIsAllSelected(false);
                    }}>
                      {t("Cancel")}
                    </button>
                    <button type="submit" className="upload-review-btn" onClick={()=>{
                        console.log('OfficeListSelected: ',selectedOfficeList)
                        getLeaderBoardData()
                    }}>
                      {t("Apply")}
                    </button>
                  </div>
                </div>
              </Dropdown.Menu>
            </Dropdown>
            {false && <Dropdown data-bs-theme="dark">
                <Dropdown.Toggle
                  className="btn-all-fillter"
                  id="dropdown-button-dark-example1"
                  variant="secondary"
                >
                  Roles
                </Dropdown.Toggle>
  
                <Dropdown.Menu>
                  <div className="dropdown-menu-filter" id="avail_menu">
                    <div className="dropdown-search">
                      <div className="dropdown-item-se pos-r">
                        <input
                          type="text"
                          className="form-control-search input_field mb-0"
                          placeholder="Search"
                        />
                        <i className="filter-searchicon"></i>
                      </div>
                    </div>
                    <div className="drop-multiselect">
                      <div className="bdr-row">
                        <div className="form-check checkallvalue">
                          <input
                            aria-label="Select all (6)"
                            tabindex="0"
                            type="checkbox"
                            class="form-check-input"
                            id="selectallvaluecontentType"
                          />
                          <label className="form-check-label" id="selectallvalue">
                            Select All
                          </label>
                        </div>
  
                        <div className="form-check">
                          <input type="checkbox" className="form-check-input" />
                          <label className="form-check-label" id="level">
                            check 1
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="filter-btnrow" id="avl_applybtn">
                      <button type="button" className="cancelbtn btn-primary d-inline">
                        Cancel
                      </button>
                      <button type="submit" className="publishbtn btn-primary d-inline">
                        Apply
                      </button>
                    </div>
                  </div>
                </Dropdown.Menu>
              </Dropdown>}
        </>)

}
export default OfficeSelectComp;